(function () {
    'use strict';

    function ForgotPasswordCtrl(restangular, toastr, $window, utilService) {
        var vm = this;
        
        vm.busy = false;
        vm.email = null;
        vm.sent = false;
        vm.sendPasswordReset = sendPasswordReset;
        vm.validationErrors = [];

        //////////////////////////////////////////
        function sendPasswordReset(form) {
            if (!form.$valid || vm.busy) return;
            vm.validationErrors = [];
            vm.busy = true;
            restangular
                .one('account')
                .post('forgotpassword', { email: vm.email })
                .then(function () {
                    vm.sent = true;
                    vm.busy = false;
                }, function (err) {
                    vm.validationErrors = utilService.parseViewModelResponse(err, utilService.errorEnum.ALL);
                    $window.scroll(0, 0);
                    toastr.error('Unable to send password instructions.', 'Error');
                    vm.busy = false;
                });
        }
    };

    angular
        .module('app')
        .controller('ForgotPasswordCtrl', [
            'Restangular', 'toastr', '$window', 'utilService', ForgotPasswordCtrl]);

})();